'use strict'

module.exports = class SaveTaxonomyPreferences extends Backbone.Model
  url: '/partial/homepage/taxonomy-preference'